import { render } from "./GraphDerivedData.vue?vue&type=template&id=5071033e&scoped=true"
import script from "./GraphDerivedData.vue?vue&type=script&lang=js"
export * from "./GraphDerivedData.vue?vue&type=script&lang=js"

import "./GraphDerivedData.vue?vue&type=style&index=0&id=5071033e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5071033e"

export default script